import { z } from "zod";
import {
  NAME,
} from "./consts";

export const schema = z.object({
  [NAME]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
